export enum ClaimType {
    AccidentalTrauma = 'AT',
    CriticalIllness = 'CI',
    Oncodrop = 'OCI',
    Death = 'DI',
    Organizational = 'organizational',
    Private = 'private',
    Mtpl = 'mtpl',
    Casco = 'casco',
    Info = 'info',
    NonInfo = 'non-info',
}
